import { guideSteps } from '@/mocks/homeData';

export default function Guide() {
  return (
    <section id="guide" className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <div className="grid gap-10 lg:grid-cols-[1fr_1.6fr] lg:gap-14">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">指路 · GUIDE</p>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            收藏与下载 · 方向指路
          </h2>
          <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600 md:text-base">
            本页只做方向指路，不直接分发内容。按下面三步走，找到你要的包、进合集、再走下载方向，一路到底不绕路。
          </p>
          <a
            href="#bigpack"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-bookmark-fill"></i>
            回到大礼包开始收藏
          </a>
        </div>

        <div className="grid gap-4 md:grid-cols-3">
          {guideSteps.map((s, i) => (
            <div
              key={s.step}
              className="relative rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-300"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-background-100 text-accent-700">
                <i className={`${s.icon} text-lg`}></i>
              </span>
              <p className="mt-4 font-mono text-xs font-bold tracking-widest text-foreground-400">STEP {s.step}</p>
              <h3 className="mt-1 text-[15px] font-bold text-foreground-950">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
              {i < guideSteps.length - 1 && (
                <span className="pointer-events-none absolute -right-2 top-1/2 hidden -translate-y-1/2 text-foreground-300 md:block">
                  <i className="ri-arrow-right-line text-base"></i>
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}